import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Wrench = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "m18.463 5.338-2.269 1.309-1.78-1.047V3.532l2.251-1.31a.21.21 0 0 0 0-.348 4.363 4.363 0 0 0-6.5 4.712l-8.168 8.15a2.312 2.312 0 1 0 3.254 3.281l8.203-8.168a4.363 4.363 0 0 0 5.323-4.337.21.21 0 0 0-.314-.174" }) }));
});
Wrench.displayName = 'Wrench';
Wrench.__iconComponentType = 'standard';
export default Wrench;
//# sourceMappingURL=Wrench.js.map